export default "__VITE_ASSET__515448c3__"